"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BYTES_IN_GB = exports.BYTES_IN_MB = exports.BYTES_IN_KB = void 0;
exports.BYTES_IN_KB = 1024;
exports.BYTES_IN_MB = 1024 * exports.BYTES_IN_KB;
exports.BYTES_IN_GB = 1024 * exports.BYTES_IN_MB;
//# sourceMappingURL=memoryConstants.js.map